export default class Locale_MatchingActivityDto {
	CreateMatchingRequest: string = "Create a matching request for all allocations";
	CreateMatchingAllocation: string = "Tries to match the request, but keeps within the resource's available capacity";
	ChoiceDisregardsEndSelection: string = "Current choice disregards end-selection in timeline and updates into the future for as long as there is data";
	ChoiceOnlyCreatesMatchingRequest: string = "Current choice only matches for the selected timeline span";
}